export const APP_VERSION = '1.7.6'
